import { useTheme } from "@hooks";

export const Security = () => {
  const { theme } = useTheme();

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0 }}
    >
      <path
        d="M10 0.833374L2.5 4.16671V9.16671C2.5 13.7917 5.7 18.1167 10 19.1667C14.3 18.1167 17.5 13.7917 17.5 9.16671V4.16671L10 0.833374ZM10 9.99171H15.8333C15.3917 13.425 13.1 16.4834 10 17.4417V10H4.16667V5.25004L10 2.65837V9.99171Z"
        fill={theme.icon.default}
      />
    </svg>
  );
};
